export function backgroundTransformer(name) {
    switch (name) {
        case 'Artic Frost':
        case 'Scarlet Sky':
            return '#CADEEB'
        case 'Peachy crepe':
        case 'Cerulean Flamingo':
        case 'Honey Caramel':
        case 'Cyan Sunset':
            return '#E9DFD5'
        case 'Blue Bubblegum':
        case 'Candy Ocean':
            return '#E9D5D5'
        case 'Pistachio Granola':
            return '#D3DAC3'
        case 'Mulberry Jam':
        case 'Liliac Moss':
            return '#E4D2E3'
        case 'Minty Blondie':
            return '#C3D6C9'
        case 'Currant Sangria':
            return '#DDD1CF'
        case 'Lemon Basil':
        case 'Navil Daffodil':
        case 'Ginger Coffee':
            return '#EAD7B0'
        default:
            return '#FFFFFF'
    }
}
